import React from "react";

const holder = {
  closeDateSelector(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.internalStateSetter({ isOpen: false });
      document.removeEventListener('mousedown', holder.closeDateSelector);
    }
  }
};

export default {
  'ItemCell.RelativeWrapper.Selector': async ({ isOpen, shouldOpen, containerRef, popupRef, hideCheckbox }, _, internalStateSetter) => {
    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = containerRef;
    shouldOpen = shouldOpen && !isOpen
    await internalStateSetter({ isOpen: shouldOpen, top: '54px', left: '0px', bottom: '' });

    const rect = popupRef?.current?.getBoundingClientRect();
    if (!(rect?.top >= 0 && rect?.bottom <= (window?.innerHeight || document.documentElement.clientHeight))) {
      await internalStateSetter({ bottom: '100%', top: '' });
    }
    if (!(rect?.left >= 0 && rect?.right <= (window?.innerWidth || document.documentElement.clientWidth))) {
      await internalStateSetter({ left: '-270px' });
    }

    if (isOpen) {
      document.removeEventListener('mousedown', holder.closeDateSelector);
    } else {
      document.addEventListener('mousedown', holder.closeDateSelector);
    }
  },
  'ItemCell.RelativeWrapper.Selector.Checkbox': ({ isSelected, isOpen, item }, outlet, internalStateSetter) => {
    outlet({ action: 'select' });
    internalStateSetter({isOpen: false, isSelected: !isSelected });
  },
  'ItemCell.RelativeWrapper.DropdownWrapper.Wrapper.ButtonsWrapper.CompleteButtonWrapper.Complete': ({ }, outlet, internalStateSetter) => {
    outlet({ action: 'toggle_complete' });
    internalStateSetter({ isOpen: false });
  },
  'ItemCell.RelativeWrapper.DropdownWrapper.Wrapper.ButtonsWrapper.Timeline': ({ }, outlet) => {
    outlet({ action: 'view_timeline' });
  },
  'ItemCell.RelativeWrapper.DropdownWrapper.Wrapper.ScheduledDate': ({ selectedDate }, outlet) => {
    outlet({ action: 'schedule', payload: { selectedDate } });
  },
  'ItemCell.RelativeWrapper.DropdownWrapper.Wrapper.Assign': ({ selectedTechId, selectedVendorId, selectedAdminId }, outlet) => {
    outlet({ action: 'assign', payload: { selectedTechId, selectedVendorId, selectedAdminId } });
  },
  'ItemCell.RelativeWrapper.DropdownWrapper.Wrapper.NoteInput': ({ mentions, uuids, value }, outlet, internalStateSetter) => {
    outlet({ action: 'note', payload: { mentions, uuids, value } });
    internalStateSetter({ displayNoteInput: false })
  },
  'ItemCell.RelativeWrapper.DropdownWrapper.Wrapper.ButtonsWrapper.Create': ({ }, outlet) => {
    outlet({ action: 'schedule', payload: { selectedDate: null } });
  },
  'ItemCell.RelativeWrapper.DropdownWrapper.Wrapper.NoteAdded': ({ }, _, internalStateSetter) => {
    internalStateSetter({ displayNoteInput: true })
  },
  'ItemCell.RelativeWrapper.DropdownWrapper.Wrapper.ViewNotes.Button': ({ displayNotes }, _, internalStateSetter) => {
    internalStateSetter({ displayNotes: !displayNotes })
  },
  'ItemCell.RelativeWrapper.DropdownWrapper.Wrapper.NoteMessage': ({ url, action, event }, outlet) => {
    outlet({ action: 'view_media', payload: { event, url } })
  },
}
